export const environment = {
    production: true,
    label: 'prod',
    API_GATEWAY_URL: 'https://api.bciti.com',
    MOD_CONFIG_URL: 'https://femodsrepository.blob.core.windows.net/fe-widgets/prod/user/user-plugins-config.json',
};
